import { useState } from "react";
import toaster from "toasted-notes";
import { useRouter } from "next/router";
import { Flex, Text, Input, VStack } from "@chakra-ui/react";
import ButtonComponent from "../src/components/common/button";

import { wrapper } from "../src/redux/store";
import Error from "../src/components/common/error";
import TopBand from "../src/components/common/topBand";

import ErrorToaster from "../src/components/common/error/errorToaster";
import SuccessToaster from "../src/components/common/toaster/success";

import { sendResetPasswordLink } from "../src/services/user";
import { fetchProductCategories } from "../src/redux/actions";

import { FORGOT_PASSWORD_FORM_SCHEMA } from "../src/constants";

const validateSchema = (values) =>
  FORGOT_PASSWORD_FORM_SCHEMA.validate(values, {
    abortEarly: false,
  });

export default function ForgotPassword({ errorMessage }) {
  if (errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }

  const router = useRouter();

  const [email, setEmail] = useState(null);
  const [error, setError] = useState(null);

  const changeEmailValue = (e) => setEmail(e.target.value);

  const handleSendResetPasswordLink = async () => {
    try {
      const response = await sendResetPasswordLink({ email });
      if (response && response.success) {
        router.push("/");
        toaster.notify(
          <SuccessToaster successMessage="Reset the password using the link sent to your email. Please check your inbox or spam folder." />,
          {
            duration: 5000,
            position: "top",
          }
        );
      } else {
        toaster.notify(<ErrorToaster errorMessage={response.message} />, {
          duration: 3000,
          position: "top",
        });
      }
    } catch (err) {
      toaster.notify(<ErrorToaster errorMessage={err.message} />, {
        duration: 3000,
        position: "top",
      });
    }
  };

  const validateForm = () => {
    validateSchema({ email })
      .then(() => {
        setError(null);
        handleSendResetPasswordLink();
      })
      .catch((err) => {
        if (err.inner) {
          setError(
            err.inner.reduce((acc, currentValue) => {
              acc[currentValue.path] = currentValue.message;
              return acc;
            }, {})
          );
        } else {
          console.log(err);
          toaster.notify(<ErrorToaster errorMessage={err.message} />, {
            duration: 3000,
            position: "top",
          });
        }
      });
  };

  return (
    <>
      <TopBand title="Forgot Password" />
      <VStack my="50px" width="100%">
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          width={{ base: "90%", "2xl": "1350px" }}
          flexDirection={{ base: "column", lg: "row" }}
        >
          <Flex width="100%" flexDirection="column">
            <Text variant="descriptionText" alignSelf="flex-start">
              Please enter email to receive reset password link:
            </Text>
            <Input
              size="lg"
              name="email"
              type="email"
              value={email}
              variant="outline"
              focusBorderColor="maroon"
              onChange={changeEmailValue}
              width={{ base: "100%", lg: "45%" }}
            />
            <Text fontSize="13px" fontWeight="600" color="red">
              {error && error.email}
            </Text>
            <ButtonComponent
              px="20px"
              mt="15px"
              title="Send"
              width="125px"
              borderRadius={4}
              backgroundColor="maroon"
              handleClick={validateForm}
            />
          </Flex>
        </Flex>
      </VStack>
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  try {
    await store.dispatch(fetchProductCategories());
  } catch (err) {
    return {
      props: {
        errorMessage: err.message,
      },
    };
  }
});
